import { oneOf, roleGuard } from './role-guard.util';

export const authGuard = roleGuard(oneOf('CANDIDATE'), '/');
